import React, { forwardRef } from 'react';
import type { FadeProps } from '@mui/material';
import { Fade as FadeMUI } from '@mui/material';

import { omitUndefinedProps } from '@/mui/helpers';

const Fade = forwardRef<HTMLElement, FadeProps>(({ children, ...props }, ref) => (
  <FadeMUI {...omitUndefinedProps(props)} ref={ref}>
    {children}
  </FadeMUI>
));

Fade.displayName = 'Fade';

export default Fade;
